import { render, staticRenderFns } from "./NotificationCenterView.vue?vue&type=template&id=dc5f5316"
import script from "./NotificationCenterView.vue?vue&type=script&lang=ts"
export * from "./NotificationCenterView.vue?vue&type=script&lang=ts"
import style0 from "./NotificationCenterView.vue?vue&type=style&index=0&id=dc5f5316&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports